/* My Acre JS — moved out of snippets/ma-trust-bubble.liquid on 16 Sep 2026 (Claude) so it caches instead of
   re-downloading inside every page's HTML. The <link>/<script> stays at the same position in the
   snippet, so the cascade and the execution order are unchanged. */
(function(){
    var root = document.querySelector('[data-ma-tb]');
    if(!root) return;
    var pill = root.querySelector('[data-ma-tb-toggle]');
    var panel = root.querySelector('#ma-tb-panel');
    var closeBtn = root.querySelector('[data-ma-tb-close]');
    if(!pill || !panel) return;
    function open(){ panel.hidden = false; pill.setAttribute('aria-expanded','true'); document.addEventListener('click', outside, true); document.addEventListener('keydown', esc); }
    function close(){ panel.hidden = true; pill.setAttribute('aria-expanded','false'); document.removeEventListener('click', outside, true); document.removeEventListener('keydown', esc); }
    function toggle(){ panel.hidden ? open() : close(); }
    function outside(e){ if(!root.contains(e.target)) close(); }
    function esc(e){ if(e.key === 'Escape' || e.keyCode === 27) close(); }
    pill.addEventListener('click', toggle);
    if(closeBtn) closeBtn.addEventListener('click', close);
  })();
